"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripExtraInfoFields = exports.TripBaseInfoFields = exports.AvailabilityFilter = exports.DepartureType = exports.PetAllowance = exports.AccommodationType = exports.WhatIsExcludedDefault = exports.WhatIsIncludedDefault = exports.InclusionStatus = exports.ExperienceLevel = exports.DifficultyLevel = exports.TourType = exports.TripType = void 0;
var TripType;
(function (TripType) {
    TripType["Guided"] = "Guided";
    TripType["SelfGuided"] = "SelfGuided";
    TripType["SemiGuided"] = "SemiGuided";
})(TripType = exports.TripType || (exports.TripType = {}));
var TourType;
(function (TourType) {
    TourType["Hiking"] = "Hiking";
    TourType["Trekking"] = "Trekking";
    TourType["Climbing"] = "Climbing";
    TourType["Cycling"] = "Cycling";
    TourType["Photography"] = "Photography";
    TourType["Cruise"] = "Cruise";
    TourType["MountainBiking"] = "MountainBiking";
    TourType["Running"] = "Running";
    TourType["Yoga"] = "Yoga";
    TourType["Family"] = "Family";
    TourType["Mountaineering"] = "Mountaineering";
    TourType["MultiSport"] = "MultiSport";
    TourType["Safari"] = "Safari";
    TourType["Skiing"] = "Skiing";
    TourType["Cultural"] = "Cultural";
    TourType["Other"] = "Other";
})(TourType = exports.TourType || (exports.TourType = {}));
var DifficultyLevel;
(function (DifficultyLevel) {
    DifficultyLevel["Easy"] = "Easy";
    DifficultyLevel["Moderate"] = "Moderate";
    DifficultyLevel["Strenuous"] = "Strenuous";
})(DifficultyLevel = exports.DifficultyLevel || (exports.DifficultyLevel = {}));
var ExperienceLevel;
(function (ExperienceLevel) {
    ExperienceLevel["Beginner"] = "Beginner";
    ExperienceLevel["Intermediate"] = "Intermediate";
    ExperienceLevel["Expert"] = "Expert";
})(ExperienceLevel = exports.ExperienceLevel || (exports.ExperienceLevel = {}));
var InclusionStatus;
(function (InclusionStatus) {
    InclusionStatus["Included"] = "Included";
    InclusionStatus["Excluded"] = "Excluded";
    InclusionStatus["None"] = "None";
})(InclusionStatus = exports.InclusionStatus || (exports.InclusionStatus = {}));
exports.WhatIsIncludedDefault = {
    allMealsIncluded: false,
    alcoholIncluded: false,
    gratuitiesIncluded: false,
    transfersIncluded: false,
    flightsIncluded: false,
    accommodationIncluded: false,
    admissionFeesIncluded: false,
    porterIncluded: false,
    visasIncluded: false,
    travelInsuranceIncluded: false,
    personalGearIncluded: false,
    guideFeesIncluded: false,
    luggageTransfersIncluded: false,
    airportTransfer: false,
    internationalFlights: false,
    domesticFlights: false,
    localGuide: false,
    someMeals: false,
};
exports.WhatIsExcludedDefault = {
    allMealsIncluded: false,
    alcoholIncluded: false,
    gratuitiesIncluded: false,
    transfersIncluded: false,
    flightsIncluded: false,
    accommodationIncluded: false,
    admissionFeesIncluded: false,
    porterIncluded: false,
    visasIncluded: false,
    travelInsuranceIncluded: false,
    personalGearIncluded: false,
    guideFeesIncluded: false,
    luggageTransfersIncluded: false,
    airportTransfer: false,
    internationalFlights: false,
    domesticFlights: false,
    localGuide: false,
    someMeals: false,
};
var AccommodationType;
(function (AccommodationType) {
    AccommodationType["Basic"] = "Basic";
    AccommodationType["Comfort"] = "Comfort";
    AccommodationType["Luxury"] = "Luxury";
})(AccommodationType = exports.AccommodationType || (exports.AccommodationType = {}));
var PetAllowance;
(function (PetAllowance) {
    PetAllowance["NoPets"] = "NoPets";
    PetAllowance["PetsFriendly"] = "PetsFriendly";
})(PetAllowance = exports.PetAllowance || (exports.PetAllowance = {}));
var DepartureType;
(function (DepartureType) {
    DepartureType["B2CCustomTrip"] = "B2C - Custom trip";
    DepartureType["B2CGuaranteedDeparture"] = "B2C - Guaranteed Departure";
    DepartureType["B2BCustomTrip"] = "B2B - Custom trip";
    DepartureType["Other"] = "Other";
})(DepartureType = exports.DepartureType || (exports.DepartureType = {}));
var AvailabilityFilter;
(function (AvailabilityFilter) {
    AvailabilityFilter["GroupAvailable"] = "GroupAvailable";
    AvailabilityFilter["GroupNoAvailability"] = "GroupNoAvailability";
    AvailabilityFilter["PrivateCustom"] = "PrivateCustom";
})(AvailabilityFilter = exports.AvailabilityFilter || (exports.AvailabilityFilter = {}));
exports.TripBaseInfoFields = [
    'tripVersionId',
    'tripId',
    'slug',
    'redirect',
    'title',
    'description',
    'country',
    'tripType',
    'tourType',
    'difficulty',
    'experience',
    'accommodationType',
    'destination',
    'days',
    'maxPeople',
    'price',
    'pricePerPerson',
    'currency',
    'itineraryOnlyPrice',
    'itineraryOnlyEnabled',
    'depositSettings',
    'starRating',
    'reviews',
    'coverImage',
    'tags',
];
exports.TripExtraInfoFields = [
    'overview',
    'cancellationPolicy',
    'whatIsIncluded',
    'whatIsExcluded',
    'tripInclusions',
    'faq',
    'itinerary',
    'accommodations',
    'gallery',
    'recommendedTrips',
    'relatedArticleTags',
    'operator',
    'startingPoint',
    'minPeople',
    'departureType',
    'internalNotes',
    'operatorTerms',
    'accommodation',
    'activities',
    'customTripMessage',
    'seoH1',
    'seoTitle',
    'seoDescription',
    'seoCanonicalSlug',
    'videoSrc',
    'food',
    'whatToExpect',
    'destinationSlugs',
    'createdAt',
    'createdBy',
    'modifiedAt',
    'modifiedBy',
];
//# sourceMappingURL=TripVersion.js.map